import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { QuickFiltersEnum, useStore } from "../../store";

export const QuickFilters = observer(function QuickFilters() {
  const store = useStore();
  return (
    <NavBar>
      <NavBar.Item
        active={store.activeQuickFilter === QuickFiltersEnum.All}
        onClick={() => store.toggleQuickFilter(QuickFiltersEnum.All)}
      >
        <Trans>All</Trans>
      </NavBar.Item>
      <NavBar.Item
        active={store.activeQuickFilter === QuickFiltersEnum.Unpaid}
        onClick={() => store.toggleQuickFilter(QuickFiltersEnum.Unpaid)}
      >
        <Trans>Unpaid</Trans>
      </NavBar.Item>
    </NavBar>
  );
});
